module.exports = __webpack_public_path__ + "img/1.cfb66dbb.jpg";